import React, { useEffect, useState } from 'react'
import { getImageUrl } from '../../utils/images'
import { getMigDetailsById } from '../../service/BrandsService'

import { useNavigate, useParams } from 'react-router-dom'
import { userActions } from '../../store/userState'
import { useDispatch, useSelector } from 'react-redux'
import { isEmail } from '../../helpers/string'
import { showMessage, showSpinner } from '../../utils/alerts'
import Swal from 'sweetalert2'

export const UserMigratedDetails = ({ selectedTab, setCurrentTab,fieldsDisabled,setfieldsDisabled }) => {
  const { emiratesID: id } = useParams()
  let emiratesID
  try {
    emiratesID = atob(id) ?? id
  } catch {
    emiratesID = ''
  }
  const dispatch = useDispatch()
  const userstate = useSelector(state => state.user)
  const [currentMigratedState, setCurrentMigratedState] = useState({})
 
  const [error, setError] = useState('')

  console.log('userstate', userstate)

  console.log('emiratesidd', emiratesID)
  const navigator = useNavigate()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    console.log('emiratesidd', emiratesID)
    getMigUserInfo()
  }, [])

  const getMigUserInfo = async () => {
    setfieldsDisabled(true)
     showSpinner('Just a moment...', 'Loading your details, please wait.')
    const response = await getMigDetailsById(emiratesID)
    console.log('emiratesdetails', response)
    console.log('emiratesdetails', response)
    console.log('emiratesdetails', response)
    console.log('response?.status', response?.status)
    const recievedProfile=response?.data?.profile;
    if (response?.status == 200 && Object.keys(recievedProfile).length > 0) {
      console.log('calling dipatch')
      setfieldsDisabled(false)
         Swal.close()
      dispatch(userActions.updateAllValues(response.data.profile))
      // setProjectDetails(response.data)
      // setIsLoading(false)
    }
    else{
      showMessage("This email address is not registered.","Please use another email address.")
      navigator("/")
    }
  }
  const updateFieldValue = (key, value) => {
    console.log(key, value)
    dispatch(userActions.updateValue({ key, value }))
    setCurrentMigratedState({ ...currentMigratedState, [key]: value })
    // console.log("currentBrandState",currentBrandState)

    console.log('currentMigratedState', currentMigratedState)
    console.log('')
  }

  const handleInputChange = e => {
    const input = e.target.value
    const regex = /^[0-9]*$/ // Allows only numbers

    if (!regex.test(input)) {
      setError('Only numeric values are allowed.')
      return
    }

    if (input.length > 10) {
      setError('Phone number cannot exceed 10 digits.')
      return
    }

    setError('')
    updateFieldValue('phoneNumber', input)
  }

  return (
    <div class='align-center justify-content-center'>
      {/* ======== */}

      {/*  */}
      <div class='text-center w-100 pr-60 '>
        <img
          src={getImageUrl('login-image.svg')}
          alt='img'
          class='w-100 mb-40 d-md-none'
        />

        <h1 class='font-20 font-weight-600 my-25'>
          {/* {otpRecieved ? '' : 'Verify User'} */}
        </h1>
        

        <form id='forgot'>
          <div className='row'>
            <div class='col-12 col-md-6 login-field align-center text-left mb-3'>
              <div class='mr-3'>
                <img src={getImageUrl('icon-mail.svg')} alt='img' />
              </div>
              <div class='form-group'>
                <label>Emirates Id*</label>
                <input
                  type='text'
                  disabled={true}
                  name='emirates-id'
                  value={userstate.emiratesID}
                  onChange={e => {
                    updateFieldValue('emiratesID', e.target.value)
                  }}
                  class='form-control'
                  placeholder='Enter here...'
                />
                {/* {requiredEmailFlag && (
                  <div className='validation-error'>
                    Please enter valid email
                  </div>
                )} */}
              </div>
            </div>
            <div class='col-12 col-md-6 login-field align-center text-left mb-3'>
              <div class='mr-3'>
                <img src={getImageUrl('icon-mail.svg')} alt='img' />
              </div>
              <div class='form-group'>
                <label data-end='*'>Registered email address*</label>
                <input
                  aria-valuenow={'Registered email address'}
                  type='email'
                  value={userstate.emailAddress}
                  disabled={true}
                  name='registered-email'
                  onChange={e => {
                    updateFieldValue('emailAddress', e.target.value)
                  }}
                  // onChange={e => HandleEmailChange(e.target.value)}
                  class='form-control mandatory'
                  placeholder='Enter here...'
                />
                {/* {requiredEmailFlag && (
                  <div className='validation-error'>
                    Please enter valid email
                  </div>
                )} */}
              </div>
            </div>
          </div>
          <div className='row'>
            <div class='col-12 col-md-6 login-field align-center text-left mb-3'>
              <div class='mr-3'>
                <img src={getImageUrl('icon-mail.svg')} alt='img' />
              </div>
              <div class='form-group'>
                <label data-end='*'>Full name*</label>
                <input
                  aria-valuenow={'Full name'}
                  type='text'
                  name='full-name'
                  disabled={fieldsDisabled}
                  maxLength={20}
                  value={userstate.fullName}
                  onChange={e => {
                    updateFieldValue('fullName', e.target.value)
                  }}
                  class='form-control mandatory'
                  placeholder='Enter here...'
                />
                {/* {requiredEmailFlag && (
                  <div className='validation-error'>
                    Please enter valid email
                  </div>
                )} */}
              </div>
            </div>
            <div class='col-12 col-md-6 login-field align-center text-left mb-3'>
              <div class='mr-3'>
                <img src={getImageUrl('icon-mail.svg')} alt='img' />
              </div>
              <div class='form-group'>
                <label data-end='*'>Organization name*</label>
                <input
                  type='text'
                  aria-valuenow={'Organization name'}
                  name='orgaization-name'
                  disabled={fieldsDisabled}
                  value={userstate.organizationName}
                  onChange={e => {
                    updateFieldValue('organizationName', e.target.value)
                  }}
                  class='form-control mandatory'
                  placeholder='Enter here...'
                />
                {/* {requiredEmailFlag && (
                  <div className='validation-error'>
                    Please enter valid email
                  </div>
                )} */}
              </div>
            </div>
          </div>{' '}
          <div className='row'>
            <div class='col-12 col-md-6 login-field align-center text-left mb-3'>
              <div class='mr-3'>
                <img src={getImageUrl('icon-mail.svg')} alt='img' />
              </div>
              <div class='form-group'>
                <label>Phone number</label>
                <input
                  type='text'
                  id='phoneNumber'
                  aria-valuenow={'Phone number'}
                  name='phone-number'
                  value={userstate.phoneNumber}
                  onChange={e => {
                    updateFieldValue('phoneNumber', e.target.value)
                  }}
                  // onChange={e => HandleEmailChange(e.target.value)}
                  class='form-control mandatory'
                  placeholder='Enter here...'
                  maxLength={10}
                />
               
              </div>
            </div>
         
          </div>{' '}
        </form>
      </div>
    </div>
  )
}
